import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { event } from '@uhg-abyss/web/tools/event';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { saveAs } from 'file-saver';

const NavItem = styled('div', {
  padding: '28px 0px 0px 0px',
});

const StyledNavLink = styled('div', {
  display: 'block',
  color: '#196ECF',
  textDecoration: 'none',
  marginBottom: '0',
});
const Heading = styled('div', {
  fontSize: '16px',
  fontWeight: '700',
  lineHeight: '24px',
  letterSpacing: '0px',
  textAlign: 'left',
  color: '#424242',
  textTransform: 'uppercase',
});

const LinkText = styled('a', {
  display: 'flex',
  padding: '4px 0px 4px 0px',
  fontSize: '15px',
  lineHeight: '20px',
  letterSpacing: '0px',
  textAlign: 'left',
  width: 'fit-content',

  '&:hover': {
    textDecoration: 'none',
    cursor: 'pointer',
  },
});

const LinkTextBold = styled('p', {
  display: 'flex',
  padding: '4px 0px 4px 0px',
  fontSize: '15px',
  lineHeight: '20px',
  letterSpacing: '0px',
  textAlign: 'left',
  width: 'fit-content',
  marginBottom: 0,
  fontWeight: 'bold',
});

const BottomMargin = styled('div', {
  marginBottom: '16px',
});

const DownloadDiv = styled('div', {
  paddingRight: '10px',
});

export const LeftNavLink = ({ data, loading, ...props }) => {
  const { navigate } = useRouter();
  const linkClick = (path) => {
    const interactionName = path.name.includes('Release Notes')
      ? 'Release Notes'
      : 'Knowledge Base';
    event('INTERACTION_EVENT', {
      interactionName,
      interactionValue: path.name,
      interactionContext: 'left navigation link click',
    });
    if (path.id.includes('download')) {
      saveAs(path.path);
    } else {
      navigate(path.path);
      // props?.handleSideNav(path.path);
    }
  };

  if (loading) {
    return (
      <NavItem>
        <LoadingSpinner isLoading={loading} />
      </NavItem>
    );
  }

  if (!data.pathsByTag) {
    return null;
  }

  return (
    <NavItem>
      {data.pathsByTag.map((tag, tagIdx) => {
        return tag.accessibleToAll ? (
          <React.Fragment key={tag.tag || tagIdx}>
            <Heading>{tag.tag}</Heading>
            <BottomMargin>
              {tag.paths.map((path, pathIdx) => {
                return (
                  <StyledNavLink key={path.id || pathIdx}>
                    {window.location.href.includes(path.id) ? (
                      <LinkTextBold>{path.name}</LinkTextBold>
                    ) : (
                      <LinkText
                        onClick={() => {
                          return linkClick(path);
                        }}
                      >
                        <DownloadDiv>{path.name}</DownloadDiv>
                        {path.id.includes('download') && (
                          <DownloadDiv>
                            <IconSymbol
                              icon="download"
                              size="16px"
                              css={{
                                'abyss-icon-material': {
                                  verticalAlign: 'middle',
                                },
                              }}
                            />
                          </DownloadDiv>
                        )}
                      </LinkText>
                    )}
                  </StyledNavLink>
                );
              })}
            </BottomMargin>
          </React.Fragment>
        ) : null;
      })}
    </NavItem>
  );
};

LeftNavLink.propTypes = {
  data: PropTypes.shape({
    pathsByTag: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  loading: PropTypes.bool.isRequired,
  handleSideNav: PropTypes.func.isRequired,
};

LeftNavLink.defaultProps = {
  data: {},
};
